import styled from "styled-components";
import EllipsisOutlined from "@ant-design/icons/EllipsisOutlined";
import { phoneMaxWidth } from "common/NewLook/layout.ts";

export const DisabledOverlay = styled.div<{ $disabled: boolean }>`
  position: relative;
  &:after {
    content: "";
    display: block;
    position: absolute;
    border-radius: 12px;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-color: ${(p) => p.theme.colors.mediumBgColor};
    opacity: ${(p) => (p.$disabled ? 0.8 : 0)};
    pointer-events: none;
  }
  button {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    height: 36px;
    transform: translate(-50%, -50%);
    ${(p) =>
      !p.$disabled &&
      `
      display: none;
    `}
  }
`;

export const TableLoadingEmpty = styled.div`
  min-height: 100px;
`;

export const Divider = styled.div`
  border-top: ${(p) => p.theme.borders.light};
  margin: 20px 0;
  @media (max-width: ${phoneMaxWidth}) {
    margin: 12px 0;
  }
`;

export const ActionsDropdownIcon = styled(EllipsisOutlined)<{
  $horizontal?: boolean;
}>`
  font-size: 28px;
  cursor: pointer;
  color: ${(p) => p.theme.colors.primaryGrey};

  ${(p) =>
    !p.$horizontal &&
    `
    transform: rotate(90deg);
  `}
  ${(p) =>
    p.theme.isNewLook &&
    `
    /* A quiet 32px target instead of the heavy 28px glyph. */
    font-size: 18px;
    padding: 7px;
    border-radius: 8px;
    color: ${p.theme.colors.secondaryText};
    transition: background-color 150ms, color 150ms;
    &:hover {
      color: ${p.theme.colors.titleColor};
      background: ${p.theme.colors.cardLightBgColor};
    }
  `}
`;
